// eslint-disable-next-line import/no-cycle
import { WsEnviaDados } from '../../websocket';

export default {
  ping: () => {
    WsEnviaDados({ tipo: 'ping', msg: '' });
  },
};
